import config from 'constants/config'
import React from 'react'
import { useIntl } from 'react-intl'
import { getPlural } from 'lib/string/pluralize'

interface Props {
  statusCredits: number
}

function FormatLoyaltyStatusCredits({ statusCredits }: Props) {
  const intl = useIntl()
  const singular = config.loyalty.statusCreditsUnit
  return <>{intl.formatMessage(
    {
      id: 'huCHOVblCn',
      defaultMessage: '{count, plural, one {# {singular}} other {# {plural}}}',
      description: 'Loyalty status credits count with dynamic unit from config',
    },
    { count: statusCredits, singular, plural: getPlural(singular) },
  )}
  </>
}

export default FormatLoyaltyStatusCredits
